import React from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import Page403 from 'app/routes/Page403';
import CircularProgress from "@material-ui/core/CircularProgress";

const ProtectedRoute = ({ allowedRoleAuthorities, requiredPermissionAuthority, ...routeProps }) => {
  const { authUser } = useSelector(({ auth }) => auth);

  const renderRoute = () => {
    for (const allowedRoleAuthority of allowedRoleAuthorities) {
      if (authUser?.roleAuthorities?.includes?.(allowedRoleAuthority)) {

        // Se não tem permissões requeridas OU é super admin
        if (!requiredPermissionAuthority ||
          authUser?.permissionAuthorities?.includes?.('PERM_BO_ADMIN')) {
          return <Route {...routeProps} />;
        }

        // Garantir que requiredPermissionAuthority é array
        const permsToCheck = Array.isArray(requiredPermissionAuthority)
          ? requiredPermissionAuthority
          : [requiredPermissionAuthority];

        // Verifica se tem pelo menos UMA permissão (lógica OR)
        const hasRequiredPermission = permsToCheck.some(
          perm => authUser?.permissionAuthorities?.includes?.(perm)
        );

        if (hasRequiredPermission) {
          return <Route {...routeProps} />;
        }
      }
    }

    return <Route component={Page403} />;
  }

  return authUser ?
    renderRoute() :
    <div className="loader-view" style={{ height: 'calc(100vh - 200px)' }}>
      <CircularProgress />
    </div>;
}

export default ProtectedRoute;
